import { useEffect, useState } from 'react'

/**
 * Whether the page has scrolled away from the very top.
 *
 * Exists for the sticky header's shadow: flat while the page rests at the top,
 * shadowed the moment content slides underneath — the design's cue that there
 * is something under the bar. Listens passively and re-checks on mount, because
 * a page can be restored mid-scroll.
 */
export const useScrolled = (): boolean => {
  const [scrolled, setScrolled] = useState(() => typeof window !== 'undefined' && window.scrollY > 0)

  useEffect(() => {
    const read = () => setScrolled(window.scrollY > 0)
    read()
    window.addEventListener('scroll', read, { passive: true })
    return () => window.removeEventListener('scroll', read)
  }, [])

  return scrolled
}
